'use strict';

angular.module('lingApp')
  .factory('RipStrings', function ($window) {

    var indexRegExp = /\{([0-9]+)\}/g;
    var camelCaseRegExp = /[A-Z]/g;

    var localeCompare = ($window.Intl
                         && angular.isObject($window.Intl)
                         && $window.Intl.Collator
                         ? new $window.Intl.Collator().compare
                         : function(a, b) { return a.localeCompare(b); });

    var methods = {
      camelCaseToSnakeCase: function(val) {
        if (!val) return val;

        return val.replace(camelCaseRegExp, '-$&').toLowerCase();
      },

      startsWith: function(val, subVal) {
        if (!_.isSpecified(val) || !_.isSpecified(subVal) || !_.isString(subVal)) {
          return false;
        }

        val = val.toString();

        if (_.isFunction(val.startsWith)) {
          return val.startsWith(subVal);
        }

        return subVal.length <= val.length && 0 === val.lastIndexOf(subVal, subVal.length);
      },

      endsWith: function(val, subVal) {
        if (!_.isSpecified(val) || !_.isSpecified(subVal) || !_.isString(subVal)) {
          return false;
        }

        val = val.toString();

        if (_.isFunction(val.endsWith)) {
          return val.endsWith(subVal);
        }

        var fromIndex = val.length - subVal.length;

        return subVal.length <= val.length && fromIndex === val.indexOf(subVal, fromIndex);
      },

      compareIgnoreCase: function(a, b) {
        if (a === b) return 0;
        if (!_.isSpecified(a)) return -1;
        if (!_.isSpecified(b)) return 1;
        a = a.toLowerCase();
        b = b.toLowerCase();

        return localeCompare(a, b);
      },

      format: function(val) {
        if (arguments.length < 2) {
          return val;
        }

        var params = arguments;

        return val.replace(indexRegExp, function(match, p) {
          return params[parseInt(p) + 1];
        });
      },

      toUnicodeCodePoints: function(val) {
        var result = [];
        for (var i = 0, ii = val.length; i < ii; ++i) {
          var codePoint = val.charCodeAt(i);
          if (0x10000 <= codePoint) ++i;
          result.push(codePoint);
        }

        return result;
      }
    };

    return methods;
  });
